
//module dgUtils {

//    //export interface IDgStateParamsService extends ng.ui.IStateParamsService {
//    //    aggregateId: string;
//    //    parentId: string;
//    //}

//    export class dgLocationService {

//        public constructor($location, $rootScope) {

//        }

//        public navigateToParentState() {
//            //todo navigate to parent state if exists
//            //var stateTo = this.$state.$current.parent;
//            //TODO: is this work?
//            var stateTo = this.$state.$current["parent"];


//            while (stateTo.parent.abstract && stateTo.self.name != 'app') {
//                stateTo = stateTo.parent;
//            }
//            var stateToParams = {};
//            angular.forEach(stateTo.ownParams, (paramName, index) => {
//                stateToParams[paramName] = this.$stateParams[paramName];
//            });
//            this.$state.go(stateTo.self.name, stateToParams);
//        };
        

//    }
//    angular.module('dgUtils')
//        .service('dgLocationService', dgLocationService);
//}